window.addEventListener("load", (event) => {
    const swatchs = document.querySelectorAll('div.swatches__list-item');

    try {
        swatchs.forEach(element => {
            const parent = element.closest('.custom-card');
            const defImg = parent.querySelector('.def');
            const hoverImg = parent.querySelector('.hover');
            const swtchTitle = parent.querySelector('.swatches__title');

            element.addEventListener('click', ()=>{
                const defImgSrc = element.getAttribute('def');
                const hoverImgSrc = element.getAttribute('hover');
                const title = element.getAttribute('name');

                if (title != "") {
                    swtchTitle.innerHTML = title;
                }
                if (defImgSrc) {
                    defImg.setAttribute('src', defImgSrc);
                }
                if (hoverImgSrc) {
                    hoverImg.setAttribute('src', hoverImgSrc);
                }
            })
        });


    } catch (error) {
        console.error("Error:", error);
    }
});
